import FEAPage from './pages/FEAPage'

export default function App() {
  return <FEAPage />
}
